<template>
  <form class="needs-validation" @submit.prevent="payment" novalidate>
    <section class="bg-white rounded mb-4 p-3 p-sm-4">
      <div class="row">
        <div class="col-12 mb-3">
          <h1 class="h2">Your Cart</h1>
          <div role="alert" class="alert alert-warning" v-if="errors">{{errors}}</div>
        </div>

        <div class="col-12" v-if="cartList">
          <table class="table table-striped table-bordered border-0" v-if="!$store.state.showExpand && cartList.length > 0 && total">
            <thead>
              <tr>
                <th class="position-relative">Horse Name</th>
                <th class="position-relative">Owner</th>
                <th class="position-relative">Age</th>
                <th class="position-relative">Sex</th>
                <th class="position-relative column-lg-small">Price</th>
                <th class="position-relative column-lg-small"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(member, index) in cartList" :key="index">
                <td>{{horseList[index].name}}</td>
                <td>{{horseList[index].owner_name}}</td>
                <td>{{horseList[index].age}}</td>
                <td>{{horseList[index].gender}}</td>
                <td align="right">${{member.price}}</td>
                <td>
                  <button :class="['btn btn-block', processing[index] ? 'btn-primary-dark' : 'btn-primary']" @click="remove(index)">
                    {{ !processing[index] ? 'Remove' : '' }}
                    <div v-if="processing[index]" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td align="right" colspan="5" class="border-0">
                  <strong>Your total: ${{total.toFixed(2)}}</strong>
                </td>
                <td class="border-0"></td>
              </tr>
              <tr>
                <td align="right" colspan="5" class="border-0"></td>
                <td class="border-0"></td>
              </tr>
            </tfoot>
          </table>

          <table class="table table-striped table-bordered border-0" v-else-if="cartList.length > 0">
            <tbody>
              <tr v-for="(member, index) in cartList" :key="index">
                <td>
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      {{horseList[index].name}}<br><br>
                      <strong>Owner: </strong> {{horseList[index].owner_name[0]}}<br>
                      <strong>Age: </strong> {{horseList[index].age}}<br>
                      <strong>Sex: </strong> {{horseList[index].gender}}<br>
                      <strong>Price: </strong> ${{member.price}}<br>
                    </div>
                    <div class="flex-shrink-1">
                      <button :class="['btn', processing[index] ? 'btn-primary-dark' : 'btn-primary']" @click="remove(index)">
                        {{ !processing[index] ? 'Remove' : '' }}
                        <div v-if="processing[index]" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td align="center" class="border-0">
                  <strong>Your total: ${{total.toFixed(2)}}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div v-else class="col-12">
          <div role="alert" class="alert alert-info">Your cart is empty</div>
        </div>

        <div class="col-12 d-flex flex-wrap justify-content-end">
          <router-link tag="button" class="btn btn-block-mob btn-outline-primary order-1 order-lg-0" :to="{ name: this.nominate === 'rookie' ? 'Nominate Rookie' : 'Confirm Horse', params: { nominate: this.nominate } }">{{`Back to ${this.nominate === 'rookie' ? 'Rookie Nomination' : 'Horse Registration'}`}}</router-link>
          <button v-if="cartList ? cartList.length > 0 : false" class="btn btn-block-mob btn-primary mb-2 mb-lg-0 ml-lg-2" @click="handleSubmit">Proceed to Payment</button>
        </div>
      </div>
    </section>
  </form>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'

export default {
  name: 'Cart',
  props: {
    cartMembers: {
      type: Object,
      default: {
        items: [],
        horses: [],
        total: 0
      }
    },
    nominate: {
      type: String,
      default: ''
    }
  },
  mixins: [HANDLESUBMIT],
  data() {
    return {
      errors: '',
      total: this.cartMembers.total,
      cartList: this.cartMembers.items,
      horseList: this.cartMembers.horses,
      // eslint-disable-next-line
      processing: this.cartMembers.items ? [...this.cartMembers.items.map(item => false)] : [],
      userID: localStorage.userID
    }
  },
  methods: {
    remove(index) {
      let data = [...this.cartList]
      if (data.length > 1) {
        data.splice(index, 1)
        data = data.filter(item => !item.hasOwnProperty('products'))
        data = data.map(item => item.id)
        this.processing.splice(index, 1, true)
        axios.post(`${this.$api}/total-cart`, { data, user_id: this.userID }).then((response) => {
          // eslint-disable-next-line
          // console.log(response.data)
          this.processing.splice(index, 1, false)
          if (response.data.status === 'success') {
            const horseData = response.data
            this.horseList.splice(index, 1)
            horseData.horses = [...this.horseList]
            this.$store.commit('updateCartMembers', horseData)
            this.$emit('cartChanged')
          }
        }).catch((error) => {
          this.processing.splice(index, 1, false)
          // eslint-disable-next-line
          console.log(error)
        })
      } else {
        this.$store.commit('updateCartMembers', { items: [], total: 0, horses: [] })
        this.$emit('cartChanged')
      }
    },
    payment() {
      setTimeout(() => {
        if (this.formComplete) {
          this.$router.push({ name: this.nominate === 'rookie' ? 'Nominate Rookie Payment' : 'Register Horse Payment', params: { nominate: this.nominate } })
        }
      }, 10)
    }
  },
  watch: {
    cartMembers() {
      this.cartList = this.cartMembers.items
      this.total = this.cartMembers.total
      // eslint-disable-next-line
      this.processing = [...this.cartMembers.items.map(item => false)]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Horses/Cart/CartDetails.vue